export default __webpack_public_path__ + "images/IF.8de056f.png";